import { baseApi } from '../apiProvider';
import { ResponsePersonalData } from '../models/response/responsePersonalData';

const personalAPI = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // get personal data of a user
    getPersonalData: builder.mutation<ResponsePersonalData, string>({
      query: (userId: string) => ({
        url: `/v0/personal-datas/${userId}`,
        method: 'GET',
      }),
    }),
    // get personal data of login user
    getSelfPersonalData: builder.mutation<ResponsePersonalData, void>({
      query: () => ({
        url: '/v0/personal-datas/me',
        method: 'GET',
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useGetPersonalDataMutation, useGetSelfPersonalDataMutation } =
  personalAPI;
